export default "__VITE_ASSET__CHYw1PRb__"